import { useEffect, useState } from "react";
import "./power.css";

export default function TimerScreen({ config, addValue,startValue, onExit, onFinish }) {
  const totalTime = config?.time === "2 Minutes" ? 120 : 60;

  const [timeLeft, setTimeLeft] = useState(totalTime);
  const [showInput, setShowInput] = useState(false);
  const [answer, setAnswer] = useState("");

  // Timer logic
  useEffect(() => {
    if (showInput) return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          setShowInput(true); 
          return 0;
        }
        return prev - 1;
      });

    }, 1000);

    return () => clearInterval(timer);
  }, [showInput]);


  return (
    <div className="power-screen">

      <div className="top-pill">Power Exercise</div>
<div className="info-text">
  {config?.exerciseType === "Addition" ? (
    <>
      Starting from 0 <br />
      Add +{addValue} for {config?.time}
    </>
  ) : (
    <>
      Starting from {startValue} <br />
      Subtract {addValue} for {config?.time}
    </>
  )}
</div>

      {/* TIMER MODE */}
      {!showInput && (
        <div className="timer-circle">
          <div>{timeLeft}</div>
          <span>sec</span>
        </div>
      )}

      {/* INPUT MODE */}
      {showInput && (
        <div className="timer-circle input-mode">

          <input
            type="number"
            placeholder="Answer"
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
            className="answer-input"
          />

          <button
            className="submit-btn"
            onClick={() => {
              const userAnswer = answer === "" ? 0 : Number(answer);
              const divisor = addValue || 1;
              let calculatedCount = 0;

              if (config?.exerciseType === "Addition") {
                calculatedCount = userAnswer / divisor;
              } else {
                calculatedCount = (startValue - userAnswer) / divisor;
              }

              const isCorrect = answer !== "" && Number.isInteger(calculatedCount) && calculatedCount >= 0;
              const finalCount = Number.isInteger(calculatedCount)
                ? calculatedCount
                : Number(calculatedCount.toFixed(2));

              onFinish({
                isCorrect,
                userAnswer,
                count: finalCount,
                addValue,
                config,
                startValue,
              });
            }}
          >
            Submit
          </button>

        </div>
      )}

      <button className="start-btn" onClick={onExit}>
        EXIT
      </button>

    </div>
  );
}